export class AbsValueConverter {
  toView(value: number): number {
    return Math.abs(value);
  }
}
